module.exports = __webpack_public_path__ + "img/img3.475b408d.png";